// extracted by mini-css-extract-plugin
export default {"arrowButton":"styles_arrowButton__pAFsU","visible":"styles_visible__smo-g"};